export const inviteFriend = {
  inviteFriendEmail: "电子邮箱",
  inviteFriendEmailError: "无效的电子邮件",
  inviteFriendDate: "日期",
  inviteFriendButton: "邀请",
  inviteFriendRegistered: "已注册的好友",
  inviteFriendLoadingList: "加载邀请名单...",
  inviteFriendNoReferrals: "没有注册的好友。",
  inviteFriendToSeeThemHere: "邀请好友以在此处查看他们",
};
